module.exports = __webpack_public_path__ + "img/4.eb9b4052.png";